export default "__VITE_ASSET__Bdb1zRLd__"